export default __webpack_public_path__ + "static/media/undraw_programmer_imem.103b30a1.svg";